export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/bce1c79c076cfd26ce49a1f2fa85ca50.svg";